module.exports = __webpack_public_path__ + "3cd6c9aa8de8d2a2fe6c5b8ba0a58172.svg";